// Tier colors — green / yellow / red traffic-light tints for Shop Mode
// rows. These are NOT axis chip colors (the reserved palette per
// CLAUDE.md is canonical/cut/category/location/state/ingredients) — they
// signal classifier output and only ever render as tier strips, dots,
// or row tints. Keeping them in their own file so a future "swap the
// red to amber" tweak is one edit.
//
// Picked to read clearly on the cream pantry surface (~#f3eee5) and the
// dark page backgrounds without colliding with the axis palette.

export const TIER_COLORS = {
  green: {
    // canonical bound — high confidence
    fg: "#3a8c5a",
    bg: "rgba(58, 140, 90, 0.10)",
    border: "rgba(58, 140, 90, 0.32)",
    strip: "#3a8c5a",
    label: "RESOLVED",
  },
  yellow: {
    // we have a name but no canonical — needs resolve later
    fg: "#c08a1f",
    bg: "rgba(192, 138, 31, 0.10)",
    border: "rgba(192, 138, 31, 0.32)",
    strip: "#c08a1f",
    label: "NAMED",
  },
  red: {
    // no name — must prompt the user inline at scan time
    fg: "#b14a3a",
    bg: "rgba(177, 74, 58, 0.10)",
    border: "rgba(177, 74, 58, 0.32)",
    strip: "#b14a3a",
    label: "UNRESOLVED",
  },
};

export function tierToneFor(tier) {
  return TIER_COLORS[tier] || TIER_COLORS.red;
}
